import React from 'react'

import {useAppSelector} from '../../../../../../hooks/react-redux'
import Icon from '../../../../../common/Icon/Icon'
import {usePipelineId} from '../../../hooks/pipeline'
import {useEditPipeline, useEditPipelineYAML} from '../../EditPipelinePage.hooks'

import styles from './EditPipelineYamlCounters.css'

function EditPipelineYamlCounters() {
  const pipelineId = usePipelineId()

  const editPipeline = useEditPipeline()
  const editPipelineYAML = useEditPipelineYAML()

  const errorsCountYAML = useAppSelector(
    state =>
      state.pipelines.pipelineYamlDraft[pipelineId]?.diagnostics?.filter(
        diagnostic => diagnostic.severity === 'error',
      )?.length ?? 0,
  )
  const warningsCountYAML = useAppSelector(
    state =>
      state.pipelines.pipelineYamlDraft[pipelineId]?.diagnostics?.filter(
        diagnostic => diagnostic.severity === 'warning',
      )?.length ?? 0,
  )

  return (
    <>
      {(editPipeline.hasChanges || editPipelineYAML.hasChanges) && (
        <span className={styles.unsavedChanges}>{'You have unsaved changes'}</span>
      )}
      {errorsCountYAML > 0 && (
        <span className={styles.errorCounter}>
          <Icon className={styles.errorIcon} name="muted" />
          {errorsCountYAML}
        </span>
      )}
      {warningsCountYAML > 0 && (
        <span className={styles.warningCounter}>
          <Icon className={styles.warningIcon} name="warning" />
          {warningsCountYAML}
        </span>
      )}
    </>
  )
}

export default EditPipelineYamlCounters
